module.exports = __webpack_public_path__ + "img/Geomatitien-BG-015.04d1381f.jpg";